module.exports = __webpack_public_path__ + "media/images/app/homepage/categories/bracelets-a4b5a864d7dca7ee9cdfaaeed7a12e5a.webp";